export const IdeaOptions = [
    { idea: 'Vo', color: 'deeppink' },
    { idea: 'Da', color: 'mediumblue' },
    { idea: 'Vi', color: 'orange' },
    { idea: 'Me', color: 'purple' },
    { idea: 'SP', color: 'darkorange' },
    { idea: 'any', color: 'black' },
];

export const MasteryChipOptions = [
    { label: 'Vo', color: 'pink' },
    { label: 'Da', color: 'lightskyblue' },
    { label: 'Vi', color: 'gold' },
    { label: 'Me', color: 'mediumpurple', textColor: 'white' },
    { label: 'SP', color: 'orange' },
    { label: '体力', color: 'palegreen' },
    { label: '上限', color: 'coral' },
    { label: 'ボーカル', color: 'pink' },
    { label: 'ダンス', color: 'lightskyblue' },
    { label: 'ビジュアル', color: 'gold' },
    { label: 'ラジオ', color: 'mediumpurple', textColor: 'white' },
    { label: 'トーク', color: 'orange' },
    { label: '撮影', color: 'mistyrose' },
    { label: 'テンション', color: 'cornflowerblue', textColor: 'white' },
    { label: 'ユニット', color: 'greenyellow' },
    { label: 'オーディション', color: 'salmon' },
    { label: 'パーフェクト', color: 'navajowhite' },
    { label: '施設', color: 'darkturquoise' },
];

export const SupportSkillChipOptions = [
    { label: '体力サポート', color: 'palegreen' },
    { label: 'おやすみブースト', color: 'aquamarine' },
    { label: 'トラブルガード', color: 'navajowhite' },
    { label: '約束リカバー', color: 'salmon' },
    { label: 'イベントブースト', color: 'greenyellow' },
    { label: 'エクセレントブースト', color: 'navajowhite' },
];

export const LPSkillChipOptions = [
    { label: '体力サポート', color: 'palegreen' },
];

export const UnitOptions = [
    'イルミネーションスターズ',
    'アンティーカ',
    '放課後クライマックスガールズ',
    'アルストロメリア',
    'ストレイライト',
    'ノクチル',
    'SHHis',
];

export const CharacterOptions = [
    { label: '真乃', unit: 'イルミネーションスターズ', color: '#ffbad6' },
    { label: '灯織', unit: 'イルミネーションスターズ', color: '#144384', textColor: 'white' },
    { label: 'めぐる', unit: 'イルミネーションスターズ', color: '#ffe012' },
    { label: '恋鐘', unit: 'アンティーカ', color: '#f84cad' },
    { label: '摩美々', unit: 'アンティーカ', color: '#a846fb', textColor: 'white' },
    { label: '咲耶', unit: 'アンティーカ', color: '#006047', textColor: 'white' },
    { label: '結華', unit: 'アンティーカ', color: '#3b91c4', textColor: 'white' },
    { label: '霧子', unit: 'アンティーカ', color: '#d9f2ff' },
    { label: '果穂', unit: '放課後クライマックスガールズ', color: '#e5461c', textColor: 'white' },
    { label: '智代子', unit: '放課後クライマックスガールズ', color: '#f93b90', textColor: 'white' },
    { label: '樹里', unit: '放課後クライマックスガールズ', color: '#ffc602' },
    { label: '凛世', unit: '放課後クライマックスガールズ', color: '#89c3eb' },
    { label: '夏葉', unit: '放課後クライマックスガールズ', color: '#90e667' },
    { label: '甘奈', unit: 'アルストロメリア', color: '#f54275', textColor: 'white' },
    { label: '甜花', unit: 'アルストロメリア', color: '#e75bec', textColor: 'white' },
    { label: '千雪', unit: 'アルストロメリア', color: '#fbfafa' },
    { label: 'あさひ', unit: 'ストレイライト', color: '#f30100', textColor: 'white' },
    { label: '冬優子', unit: 'ストレイライト', color: '#5ce626' },
    { label: '愛依', unit: 'ストレイライト', color: '#ff00ff' },
    { label: '透', unit:'ノクチル', color: '#50d0d0' },
    { label: '円香', unit:'ノクチル', color: '#be1e3e', textColor: 'white' },
    { label: '小糸', unit:'ノクチル', color: '#7967c3', textColor: 'white' },
    { label: '雛菜', unit:'ノクチル', color: '#ffc639' },
    { label: 'にちか', unit:'SHHis', color: '#9DC3AC' },
    { label: '美琴', unit:'SHHis', color: '#6F1419', textColor: 'white' },
];

export const DistributionTypeOptions = [
    { label : '恒常', color: 'aliceblue'},
    { label : '限定', color: 'aliceblue'},
    { label : 'イベント', color: 'aliceblue'},
    { label : '配布', color: 'aliceblue'},
];